import { Observer, observer } from "mobx-react-lite";
import React, { ReactNode, useEffect, useRef, useState } from "react";
import { BioText } from "../components/BioText"
import { ErrorModal } from "../components/ErrorModal";
import { MainProfileImage } from "../components/MainProfileImage";
import { SubProfileImage } from "../components/SubProfileImage"
import { useAudioPlayer } from "../customHooks/useAudioPlayer";
import { RecorderType } from "../models/app/RecorderType";
import { appConfig, MAX_VINTRO_TIME } from "../models/constants"
import { rootStore } from "../StApp";
import { ProfileStore } from "../stores/ProfileStore";
import { RecorderStore } from "../stores/RecorderStore";
import { useModal } from 'react-hooks-use-modal';
import { useHistory } from "react-router";
import EditPrompts from "../components/EditPrompts";
import { motion } from "framer-motion";
import { Transitions } from "../transitions/pageTransitions";

type AudioMode = 'PLAYER' | 'RECORDER'

const modalStyle: React.CSSProperties = {
    backgroundColor: '#fff',
    padding: '40px 20px',
    borderRadius: '10px',
    width: '200px'
};


function ProfileSubImageHolder(props: { store: ProfileStore }) {
    return (<div className='flex-row'>
        <SubProfileImage index={1} src={appConfig.DUMMY_IMG_URL} main={true} key={1} uid={rootStore.mainStore.uid!}
            editMode='EDIT'
            store={props.store} />
        <div className='flex-column' >
            <SubProfileImage index={2} src={appConfig.DUMMY_IMG_URL} key={2} uid={rootStore.mainStore.uid!}
                editMode='EDIT'
                store={props.store} />
            <SubProfileImage index={3} src={appConfig.DUMMY_IMG_URL} key={3} uid={rootStore.mainStore.uid!}
                editMode='EDIT'
                store={props.store} />
        </div>
    </div>);
}



const VIntroPlayer = observer((props: { audioUrl?: string, profileStore: ProfileStore }) => {

    const { audioRef, duration, isPlayingState, pauseAudio, playAudio, curTime, setDuration } = useAudioPlayer()
    const [audioModeState, setAudioModeState] = useState<AudioMode>('PLAYER')
    const [recorderStore] = useState(new RecorderStore(RecorderType.INTRO))
    const [audioUrl, setAudioUrl] = useState(props.audioUrl)
    const prevAudioUrl = useRef<string>('')

    let timer = recorderStore.recordTimer
    let x = props.profileStore.voiceIntrolUrl

    useEffect(() => {

        if (recorderStore.blob != null) {
            props.profileStore.setVoiceIntroData(recorderStore.blob)
            setAudioUrl(recorderStore.srcUrl)
        }
    }, [recorderStore.recordState])

    useEffect(() => {
        if (recorderStore.blob == null)
            setAudioUrl(props.profileStore.voiceIntrolUrl)
    }, [props.profileStore.voiceIntrolUrl])

    useEffect(() => {
        if (x)
            prevAudioUrl.current = x
    })

    function getDuration() {
        if (audioModeState == 'PLAYER')
            return curTime / duration * 100
        else
            return recorderStore.recordTimer / MAX_VINTRO_TIME * 100

    }

    function startRecording() {
        setAudioModeState('RECORDER')
        recorderStore.recordSound()
    }

    function stopRecording() {
        setAudioModeState('PLAYER')
        recorderStore.stopRecording()
    }

    function play() {
        setAudioModeState('PLAYER')
        playAudio()
    }

    function pause() {
        //setAudioModeState('PLAYER')
    }

    function resetAudio() {
        props.profileStore.updateSameVoiceIntro()
        setAudioUrl(prevAudioUrl.current)
    }

    function deleteAudio() {
        props.profileStore.deleteVoiceIntroData()
        setAudioUrl('')
        setDuration(0)
    }


    return (<div className='flex-row vintro-player-container' >
        <audio ref={audioRef} src={audioUrl} preload='metadata' ></audio>
        <div className='vintro-player'>{
            !isPlayingState ? <i className="material-icons"
                onClick={play}
                style={{
                    fontSize: 25,
                    zIndex: 10,
                    color: duration > 0 ? 'black' : 'gray'
                }}>play_arrow</i> :
                <i className="material-icons"
                    onClick={pauseAudio}
                    style={{
                        fontSize: 25,
                        zIndex: 10,
                    }}>pause</i>
        }</div>
        <div className='vintro-status relative ' >
            <p style={{ position: 'absolute', left: 10 }} >{Math.ceil(duration == 100 ? 0 : duration)} sec</p>
            <div style={{ width: `${getDuration()}%`, height: '100%', backgroundColor: 'green' }} />
            <div className='flex-row' style={{ position: 'absolute', right: 10 }} >
                <span className="material-icons-outlined" onClick={resetAudio} >
                    restart_alt
                </span>
                <span className="material-icons-outlined" onClick={deleteAudio} >
                    delete
                </span>
            </div>
        </div>
        <div className='vintro-recorder' >
            {recorderStore.recordState == 'recording' ?
                <i className="material-icons-outlined"
                    onClick={stopRecording}
                    style={{ fontSize: 30, color: 'red' }} >stop_circle</i> :
                <i className="material-icons"
                    onClick={startRecording}
                    style={{
                        fontSize: 25,
                        zIndex: 10,
                    }}>mic</i>
            }
        </div>
    </div>);
})



const ProfileHead = observer((props: { profileStore: ProfileStore }) => {

    const store = props.profileStore

    return (<div className='flex-row center-align'>
        <MainProfileImage src={appConfig.DUMMY_IMG_URL} uid={rootStore.mainStore.uid!} store={store} />
        <div className='flex-column' style={{
            marginLeft: 10
        }}>
            <input className='input-styled' type="text" placeholder='Your Name'
                value={store.name} onChange={(e) => { store.updateName(e.target.value) }} />
            <input className='input-styled' type="text" placeholder='Your Nick Name'
                value={store.nickName} onChange={(e) => { store.updateNickName(e.target.value) }} />
            <input className='input-styled' type="text" placeholder='Where you from?'
                value={store.place} onChange={(e) => { store.updatePlace(e.target.value) }} />
            <input className='input-styled' type="text" placeholder='Your email' disabled
                value={store.email??''} onChange={(e) => { store.updateEmail(e.target.value) }} />
            <input className='input-styled' type="text" placeholder='Dob as dd/mm/yyyy'
                value={store.dob} onChange={(e) => { store.updateDob(e.target.value) }} />
        </div>
    </div>);
})

const DeleteAccModal = observer((props: {
    Modal: React.FC<{
        children: React.ReactNode;
    }>, close: () => void,
    store: ProfileStore
}) => {

    const Modal = props.Modal
    const store = props.store

    function getStatus(): ReactNode {

        switch (store.deleteProfileProg) {

            case 'INIT': return 'DELETE'
                break;
            case 'LOADING': return <progress className="pure-material-progress-circular" />
                break;
            case 'FAILED': return 'DELETE'
                break;
            case 'SUCCESS': return 'DELETE'

        }
    }

    function deleteProfile() {
        store.deleteProfile()
    }

    return (
        <Modal>
            <div style={modalStyle} >
                <h3>Delete Account?</h3>
                <p>Type "delete" and press DELETE button</p>
                <input type="text" maxLength={6} onChange={e => store.updateDeleteText(e.target.value)} />
                <button className='button-5 button-delete' onClick={deleteProfile}
                    disabled={store.deleteText != 'delete'}
                >{getStatus()}</button>
            </div>
        </Modal>
    )
})


export const UserProfile = () => {

    const [store] = useState(new ProfileStore())
    const history = useHistory()
    //const [isOpen, setIsOpen] = useState(false)
    const [Modal, open, close, isOpen] = useModal('root', {
        preventScroll: true,
        closeOnOverlayClick: true
    });

    useEffect(() => {
        store.loadProfile()
    }, [])

    useEffect(() => {
        document.title = 'My Profile'
    }, [])

    function updateProfile() {
        store.updateProfile()
    }

    function goToHome() {
        history.replace('/stapp/home')
        rootStore.uiStore.updateBottomNavIndex(0)
    }

    return (
        <motion.div className='flex-column center-align absolute'
            initial="initial"
            animate="in"
            exit="out"
            variants={Transitions.pageVariants}
            transition={Transitions.pageTransition}
            style={{height: '100%', overflow:'scroll'}}
        >
            <DeleteAccModal Modal={Modal} close={close} store={store} />
            <div className='flex-row' style={{ justifyContent: 'space-between', alignItems: 'center', width: '90%' }} >
                <div className='flex-row center-both ' >
                    <span className="material-icons-outlined" style={{ fontSize: 30, marginRight: 5 }} onClick={goToHome} >
                        home
                    </span>
                    <h2>My Profile</h2>
                </div>
                <Observer>{() => {
                    return <button className='button-save-profile' onClick={updateProfile} >
                        {store.updateProfileLoadProg == 'LOADING' ? <progress className="pure-material-progress-circular" />
                            : 'Save'
                        }
                    </button>
                }}</Observer>
            </div>
            <div style={{ height: 10 }} ></div>
            <ProfileHead profileStore={store} />
            <div style={{ height: 10 }} ></div>
            <h3 >Please add your best photos to show off :p</h3>
            <ProfileSubImageHolder store={store} />
            <h3>Please introduce yourself</h3>
            <p style={{ margin: '0px 10px', textAlign: 'center' }} >(May be your name's pronunciation or what's your work like?)</p>
            <VIntroPlayer profileStore={store} audioUrl={store.voiceIntrolUrl} />
            <BioText store={store} />
            <EditPrompts store={store} />
            <button style={{ marginBottom: 20 }} onClick={open} >Delete Account</button>
        </motion.div>
    )
}

